import { Attribute, ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';

import { AppIcon, AppIconName } from '../icon.type';
import { AppIconsLibrary } from '../icons-library.service';
import { iconFingerTap } from 'main/icons/icon-finger-tap';
import { MediaQuery } from 'core/services/media-query.service';

@Component({
  selector: 'app-icon',
  template: ``,
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input({ required: true })
  set icon(i: AppIconName | AppIcon | undefined) {
    if (i !== this._icon) {
      i = i || '';
      const prev = this._icon;
      this._icon = i;
      this.updateIcon(i, prev);
    }
  }

  private _icon: AppIconName | AppIcon = '';

  constructor(
    public elementRef: ElementRef<HTMLElement>,
    private icons: AppIconsLibrary,
    private media: MediaQuery,
    private renderer: Renderer2,
    @Attribute('no-scaling') public noScaling: string,
    @Attribute('stroke-diff') public strokeDiff: string,
    @Attribute('no-class') public noClass: string,
  ) {}

  private updateIcon(current: AppIconName | AppIcon, previous: AppIconName | AppIcon): void {
    let rawSvg: string;
    let currentClass = '';
    const previousClass = typeof previous === 'object' ? previous.name : previous;
    if (typeof current === 'object') {
      if(current.name === 'cursor' && this.media.isSmall()) {
        current = iconFingerTap;
      }
      rawSvg = current.svgData;
      currentClass = current.name;
    } else {
      currentClass = current;
      rawSvg = this.icons.getIcon(current)?.svgData || '';
    }
    if (!rawSvg) {
      return;
    }
    rawSvg = rawSvg
      .replace('<svg', '<svg class="svg-icon" ')
      .replace(/data-fill/g, 'fill')
      .replace(/data-stroke/g, 'stroke');
    if (this.noScaling) {
      rawSvg = rawSvg.replace(/stroke-width="/g, ' vector-effect="non-scaling-stroke" stroke-width="');
    } else if (this.strokeDiff) {
      rawSvg = this.adjustStrokeWidth(rawSvg, +this.strokeDiff);
    }
    this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', rawSvg);
    if (!this.noClass) {
      this.renderer.addClass(this.elementRef.nativeElement, 'icon');
      if (previousClass) {
        this.renderer.removeClass(this.elementRef.nativeElement, previousClass);
      }
      if (currentClass) {
        this.renderer.addClass(this.elementRef.nativeElement, currentClass);
      }
    }
  }

  private adjustStrokeWidth(svgString: string, strokeDiff: number): string {
    return svgString.replace(/stroke-width="([\d.]+)"/g, (_, n) => {
      const updatedWidth = parseFloat(n) + strokeDiff;
      return `stroke-width="${updatedWidth}"`;
    });
  }
}
